import { getQueryString } from "./common-methods";

let base_url_container = "";
let pdf_base_url = "https://www.visualize-roi.com";

switch (window.location.hostname) {
  case "localhost":
    base_url_container = "https://www.visualize-roi.com";
    //base_url_container = 'https://test.visualizeroi.com';
    break;
  default:
    // base_url_container = window.location.protocol + '//' + window.location.hostname;
    base_url_container = "https://www.visualize-roi.com";
    pdf_base_url = "https://staging.visualize-roi.com";
    break;
}

export const base_url = base_url_container;
export const query_string = getQueryString();
// export const pdf_url =
//   "http://test.visualizeroi.com/vr/services_uis/self_service/cloudbees/thankyou.html?script_id=";
export const pdf_url =
  pdf_base_url + "/vr/customer/ui/diamanti/thankyou.html?script_id=";
export const fileName = "Diamanti Report";

// let serverURL2 = "https://test.visualizeroi.com/vr/";
// const hostname = window && window.location && window.location.hostname;

// if (hostname === "staging.visualize-roi.com")
//     serverURL2 = "https://staging.visualize-roi.com/vr/";
// else if (hostname === "staging.visualize-roi.com")
//     serverURL2 = "https://www.visualize-roi.com/vr/";
